









import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";

@Component({
  components: {}
})
export default class CoinsTitleSeparate extends Vue {
  @Prop({ default: "Followers" })
  private type?: any;
  @Prop({ default: "" })
  private content?: any;
}
